import React, { Component } from 'react';
import { Grid, Button, Icon, Input } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import styled from 'styled-components';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul'); // 서버시간과 다를경우를 대비하여 설정함

class DatePickerController extends Component {
  handleChange = date => {
    this.props.onChange(date);
  };

  handleClick = e => {
    this.props.onSelect(e);
  };

  render() {
    const { date, text } = this.props;

    return (
      <GridRowStyled columns={3} id="calendar">
        <GridColumnStyled width={2} className="calendar__prev">
          <Button
            icon
            name="PREV"
            labelPosition="left"
            onClick={this.handleClick}
          >
            <Icon name="left angle" />
            {text.prev}
          </Button>
        </GridColumnStyled>
        <GridColumnStyled
          width={12}
          align="center"
          className="calendar__select-days"
        >
          <Input
            labelPosition="right"
            type="text"
            placeholder="Amount"
            className="form-element"
          >
            <DatePicker
              selected={date}
              onChange={this.handleChange}
              dateFormat="YYYY-MM-DD"
            />
          </Input>
        </GridColumnStyled>
        <GridColumnStyled width={2} className="calendar__next">
          <Button
            icon
            name="NEXT"
            labelPosition="right"
            onClick={this.handleClick}
          >
            {text.next}
            <Icon name="right angle" />
          </Button>
        </GridColumnStyled>
      </GridRowStyled>
    );
  }
}

const GridRowStyled = styled(Grid.Row)`
  &&&& {
    margin-top: 1rem;
  }
`;

const GridColumnStyled = styled(Grid.Column)`
  &&&& {
    padding-left: 1rem;
    padding-right: 1rem;
  }
`;

export default DatePickerController;
